import React from 'react';
import Radio from '@mui/material/Radio';
import { makeStyles } from 'tss-react/mui';

export type RadioProps = import('@mui/material/Radio').RadioProps;

const useStyles = makeStyles()(theme => ({
  root: {
    color: theme.palette.grey[700],
  },
}));

const CustomRadio: React.FC<RadioProps> = ({ color, ...rest }) => {
  const { classes } = useStyles();

  return (
    <Radio className={classes.root} color={color || 'primary'} {...rest} />
  );
};

export { CustomRadio };
